import AdminUpload from "components/orders/AdminUpload";
import UploadedListItem from "components/reusable/UploadListItem";
import { usePublicAttachmentForCustomerStatus } from "hooks/queries/usePublicAttachment";
import { useTranslation } from "react-i18next";
import { InstallationSchema } from "types/installation";

export default function FilesTab({
  installation,
}: {
  installation: InstallationSchema;
}) {
  const { t } = useTranslation();
  const { mutateAsync: updatePublicAttachmentStatus } =
    usePublicAttachmentForCustomerStatus();

  const handlePublicAttachmentChange = (file: {
    id: string;
    isForCustomer: boolean;
  }) => {
    updatePublicAttachmentStatus(file);
  };

  return (
    <div>
      <div>
        <h5 className="underline">{t("orders:modalTabs:files")}</h5>
      </div>
      <div>
        <AdminUpload installation={installation} />
      </div>

      <div style={{ marginTop: "2rem" }} className="responsive-two-column">
        <div></div>
        <div>
          <h6 className="underline">{t("upload:customerAttachments")}:</h6>
          {installation.publicAttachments &&
          installation.publicAttachments.length > 0 ? (
            <div className="flex flex-col gap-2" style={{ marginTop: "1rem" }}>
              {installation.publicAttachments.map((file) => (
                <UploadedListItem
                  key={file.id}
                  file={file}
                  forCustomerFileStatus={handlePublicAttachmentChange}
                />
              ))}
            </div>
          ) : (
            "-"
          )}
        </div>
      </div>
    </div>
  );
}
